import { makePersisted } from "@solid-primitives/storage";
import { createSignal } from "solid-js";
import { createStore } from "solid-js/store";
import { isServer } from "solid-js/web";

export type UIStore = ReturnType<typeof createUIService>;

export type AuthGateModalState = {
  title: string;
  description?: string;
};

// Bits and bobs for app-wide UI state
// TODO: @andi Refactor the AppUIContext into this service so everything is centralized
export const createUIService = () => {
  const [state, setState] = createStore({
    creditsGateModal: "",
    chatPermissionsGateModal: false,
    manageLabelsModal: false,
    processingAssetsGateModal: false,
    processingAssetsGateAction: null as null | (() => unknown),
    authGateModal: null as null | AuthGateModalState,
    chatAccessDeniedModal: false,
  });

  const [closedConcepts, setClosedConcepts] = makePersisted(createSignal(false), {
    storage: isServer ? undefined : localStorage,
    name: "chat-related-concepts-closed",
  });

  return {
    conceptsPoweringChat: {
      closed: () => closedConcepts(),
      setClosed: (closed: boolean) => setClosedConcepts(closed),
    },
    creditsGate: {
      isModalOpen: () => state.creditsGateModal !== "",
      description: () => state.creditsGateModal,
      openModal: (description: string) => setState("creditsGateModal", description),
      closeModal: () => setState("creditsGateModal", ""),
    },
    chatPermissionsGate: {
      isModalOpen: () => state.chatPermissionsGateModal,
      openModal: () => setState("chatPermissionsGateModal", true),
      closeModal: () => setState("chatPermissionsGateModal", false),
    },
    manageLabels: {
      isModalOpen: () => state.manageLabelsModal,
      openModal: () => setState("manageLabelsModal", true),
      closeModal: () => setState("manageLabelsModal", false),
    },
    processingAssetsGate: {
      isModalOpen: () => state.processingAssetsGateModal,
      executeGatedAction: () => state.processingAssetsGateAction?.(),
      // biome-ignore lint/suspicious/noExplicitAny: Type doesn't matter
      openModal: (action?: () => any) => {
        setState("processingAssetsGateAction", () => action ?? null);
        setState("processingAssetsGateModal", true);
      },
      closeModal: () => {
        setState("processingAssetsGateAction", null);
        setState("processingAssetsGateModal", false);
      },
    },
    authGate: {
      isModalOpen: () => state.authGateModal !== null,
      state: () => state.authGateModal,
      openModal: (options: AuthGateModalState) => setState("authGateModal", options),
      closeModal: () => setState("authGateModal", null),
    },
    chatAccessDenied: {
      isModalOpen: () => state.chatAccessDeniedModal,
      openModal: () => setState("chatAccessDeniedModal", true),
      closeModal: () => setState("chatAccessDeniedModal", false),
    },
  };
};
